import styles from './productsIntro.module.css';
import { motion } from "framer-motion";
import SectionTitle from '../../sectionTitle/SectionTitle';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';


export default function ProductsIntro({ data }) {

  return (
    <section className={`${styles.container} d-flex flex-column `}>
      <SectionTitle title={data?.name} className='text-center mb-5' />
      <div className={`${styles.productIntroduction} container-lg`}>

        <div className={styles.rightPanel_container}>
          {data?.products.slice(0, 3).map((product) =>
            <motion.div className={styles.rightBranch} key={product.id}
              initial={{ opacity: 0, x: 150 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 1, ease: "easeOut" }}
            >
              <div>
                <strong className={styles.rightTitle}>{product.name}</strong>
                <p className={styles.rightDesc}>{product.description}</p>
              </div>
              <div className={styles.image_wrapper}>
                <img className={styles.image} src={product.image} alt={product.name} loading='lazy' />
              </div>
            </motion.div>
          )}
        </div>

        <motion.div className={styles.midPanel}
          initial={{ opacity: 0, scale: 0.7 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: false, amount: 0.2 }}
          transition={{ duration: 1, ease: 'easeOut' }}
        >
          <Swiper
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            loop={true}
            pagination={{
              clickable: true,
            }}
            navigation={true}
            modules={[Autoplay]}
            className={styles.swiper}
          >
            {data?.products.map(product =>
              <SwiperSlide className={styles.swiperSlide} key={product.id}><img src={product.image} alt={product.name} loading='lazy' /></SwiperSlide>
            )}
          </Swiper>
        </motion.div>

        <div className={styles.leftPanel_container}>
          {data?.products.slice(3).map((product) =>
            <motion.div className={styles.leftBranch} key={product.id}
              initial={{ opacity: 0, x: -150 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 1, ease: "easeOut" }}
            >
              <div className={styles.image_wrapper}>
                <img className={styles.image} src={product.image} alt={product.name} loading='lazy' />
              </div>
              <div>
                <strong className={styles.leftTitle}>{product.name}</strong>
                <p className={styles.leftDesc}>{product.description}</p>
              </div>
            </motion.div>
          )}
        </div>

      </div>
    </section >
  )
}
